;(function (angular) {
  'use strict'

  angular
    .module('kilo.config')
    .constant('populates', {
      show: {
        creditNote: [
          { path: 'client' },
          { path: 'delivery' },
          { path: 'tags' },
          { path: 'referers' },
          { path: 'lines.subcontracts.entity' },
          { path: 'lines.product.productType' },
          { path: 'lines.productType' },
          { path: 'facturXAttachments' }
        ],
        invoice: [
          { path: 'client' },
          { path: 'delivery' },
          { path: 'tags' },
          { path: 'referers' },
          { path: 'bpu', populate: [{ path: 'client' }] },
          { path: 'lines.subcontracts.entity' },
          { path: 'facturXAttachments' },
          { path: 'lines.product.productType' },
          { path: 'lines.productType' },
          { path: 'invoiceDeposit' }
        ],
        quote: [
          { path: 'facturXAttachments' }
        ]
      }
    })
})(window.angular)
